module.exports = __webpack_public_path__ + "static/media/south-coast.d4e9e1ad.jpg";